const normalizeValue = (entry) => {
  const raw = entry !== null && typeof entry === "object" ? entry.value : entry;
  return String(raw ?? "")
    .trim()
    .toLowerCase();
};

/**
 * Key of the header-dashboard tile whose filter combination equals the applied filters,
 * else null. Values are unwrapped (`{ value }`), trimmed and lower-cased; empty values and
 * `neutralValues` (radio "No Filter", "Do not show archived", ...) are ignored so they cannot
 * break the match. Any other extra value (e.g. `show_archived`) still prevents a match.
 */
export const matchIndicatorKey = (appliedValues, indicatorMap, neutralValues = []) => {
  const neutral = new Set(neutralValues.map(normalizeValue));
  const applied = new Set(
    (appliedValues || []).map(normalizeValue).filter((value) => value && !neutral.has(value))
  );
  return (
    Object.keys(indicatorMap || {}).find((key) => {
      const target = new Set(indicatorMap[key].map(normalizeValue));
      return target.size === applied.size && [...target].every((value) => applied.has(value));
    }) || null
  );
};
